@if(gender){
<img class="gender-icon" [src]="getIcon()" />
}